import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InsurancePayer } from 'src/app/models/type/insurance-payer';
import { FormComponentControl } from 'src/app/shared/inputs/form-component-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-insurance-payer',
  templateUrl: './input-insurance-payer.component.html',
  styleUrls: ['./input-insurance-payer.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputInsurancePayerComponent),
      multi: true
    }
  ]
})
export class InputInsurancePayerComponent extends FormComponentControl implements OnInit {
  @Input() label: any;
  errors = inputMgsErrs.insurancePayer;
  private _isDisabled;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) {
    super(cc);
  }

  get self(): string {
    return InsurancePayer.Self.toString();
  }

  get anotherPerson(): string {
    return InsurancePayer.AnotherPerson.toString();
  }

  set isDisabled(val: boolean) {
    this._isDisabled = val;
  }

  get isDisabled() {
    return this.control ? (this.control.status === 'DISABLED') : this._isDisabled;
  }


  ngOnInit() {
    this.checkInitialControl();
  }

}
